module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/staff-watanabe-50e5ad87631a5856de1f02058ec5f49d.webp";